import * as React from "react";
import { Spoiler as MantineSpoiler } from "@mantine/core";
const Spoiler = ({
  maxHeight,
  children = void 0,
  className = void 0,
  showLabel = "Show more",
  hideLabel = "Hide"
}) => /* @__PURE__ */ React.createElement(MantineSpoiler, { maxHeight, showLabel, hideLabel, className }, children);
export default Spoiler;
